import { useRef } from 'react';

//https://github.com/streamich/react-use/blob/master/src/useFirstMountState.ts
function useFirstMountState() {
    var isFirst = useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

export { useFirstMountState };
//# sourceMappingURL=index.js.map
